import * as React from 'react'

import {
  InlineEditTextField,
  type InlineEditTextFieldStatus,
} from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const NAME_MAX_LENGTH = 200

export interface IEditablePOCustomFieldTextFieldProps {
  value: string
  status: InlineEditTextFieldStatus
  onChange: (value: string) => void
  /** Commit the current value (fired on blur and Enter) */
  onCommit: () => void
  /** Revert to the persisted value (fired on Escape) */
  onEscape: () => void
}

export const EditablePOCustomFieldTextField = ({
  value,
  status,
  onChange,
  onCommit,
  onEscape,
}: IEditablePOCustomFieldTextFieldProps) => {
  const intl = useProcurifyIntl()

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      onCommit()
    } else if (e.key === 'Escape') {
      onEscape()
    }
  }

  return (
    <InlineEditTextField
      value={value}
      status={status}
      onChange={onChange}
      onBlur={onCommit}
      onKeyDown={handleKeyDown}
      placeholder={intl.formatMessage(messages.inputPlaceholder)}
      ariaLabel={intl.formatMessage(messages.inputAriaLabel)}
      maxLength={NAME_MAX_LENGTH}
      statusAriaLabels={{
        idle: intl.formatMessage(messages.statusIconIdleAriaLabel),
        pending: intl.formatMessage(messages.statusIconPendingAriaLabel),
        resolved: intl.formatMessage(messages.statusIconResolvedAriaLabel),
        rejected: intl.formatMessage(messages.statusIconRejectedAriaLabel),
      }}
    />
  )
}

EditablePOCustomFieldTextField.displayName = 'EditablePOCustomFieldTextField'
